export enum CartPaymentStateEnum {

  Waiting = 0,
  Success = 1,
  Error = 2,
  WaitingValidation = 3

}
